import React from "react"
import { github, mail, twitter } from "../../utils/svgs"

import "./footer.css"

export const Footer = () => (
  <footer className="footer">
    {/* <a
      href="https://www.twitter.com/talipakcelik"
      className="footer__emoji"
      target="_blank"
      rel="noopener noreferrer"
    >
      {" "}
      <img src={twitter}></img>
    </a> */}
    <a
      href="https://www.github.com/talipakcelik"
      className="footer__emoji"
      target="_blank"
      rel="noopener noreferrer"
    >
      {" "}
      <img src={github}></img>
    </a>
    <a
      href="mailto:talipakcelik@gmail.com"
      target="_top"
      rel="noopener noreferrer"
    >
      {" "}
      <img src={mail} className="footer__emoji"></img>
    </a>
  </footer>
)
